import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";

import { useFormWithNotification } from "@covertree/hooks";
import { AddressAutocompletePrecisely } from "@covertree/features";
import { FormDatePicker, FormTextField, LoadingFrame } from "@covertree/ui";

import { useAppSelector } from "@redux/hooks";
import { selectPolicyDetails } from "@redux/slices";

import { policyDetailsFormValidator } from "./form";
import { ClaimsForm } from "../ClaimsForm";
import { useFindPolicyFormClaimByAddress } from "./useFindPolicyFormClaimByAddress";

export function PolicyDetails() {
  const { findPolicyForClaim, loading } = useFindPolicyFormClaimByAddress();
  const defaultValues = useAppSelector(selectPolicyDetails);

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: {
      ...defaultValues,
      lotUnit: defaultValues.address?.value.lotUnit || "",
    },
    resolver: yupResolver(policyDetailsFormValidator),
  });
  const { control, setValue, watch } = form;

  const address = watch("address");

  useEffect(() => {
    if (address?.value) {
      setValue("lotUnit", address.value.lotUnit ?? "");
    }
  }, [address, setValue]);

  if (loading) {
    return (
      <LoadingFrame
        image="/animations/spinner.gif"
        messages={["Looking up policy details"]}
        maxLoadTime={5}
      />
    );
  }

  return (
    <ClaimsForm form={form} onSubmit={findPolicyForClaim}>
      <Grid item xs={12} container flexDirection="row" spacing={3}>
        <Grid item xs={12} md={8}>
          <AddressAutocompletePrecisely
            id="policy-claim-address"
            dataTestId="policy-claim-address"
            name="address"
            label="Address"
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormTextField
            id="unit-id"
            dataTestId="unit-number-testId"
            name="lotUnit"
            label="Unit / Lot#"
            control={control}
            optional
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormDatePicker
          id="lost-date"
          dataTestId="lost-date"
          name="dateOfLoss"
          label="Date of Loss"
          control={control}
          disableFuture
        />
      </Grid>
    </ClaimsForm>
  );
}
